import { Outlet } from "react-router-dom";
import { Footer } from "./Footer";

/**
 * Business layout wrapper that includes Footer.
 * Header is embedded inside each page's hero section
 * (matching residential pattern for consistent nav placement).
 */
export function BusinessLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
